import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiHome, FiUsers, FiSettings, FiUser, FiTool, FiBarChart2, FiHelpCircle } from 'react-icons/fi';
import { useRole } from '../../hooks/useRole';

export default function LeftNavigation() {
  const [isExpanded, setIsExpanded] = useState(true);
  const location = useLocation();
  const { hasAdminAccess } = useRole();

  const navItems = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      icon: FiHome,
    },
    {
      name: 'Teams',
      path: '/teams',
      icon: FiUsers,
    },
    {
      name: 'Team Agents',
      path: '/team-agents',
      icon: FiUsers,
    },
    {
      name: 'AI Agents',
      path: '/agents',
      icon: FiUser,
    },
    {
      name: 'Analytics',
      path: '/analytics',
      icon: FiBarChart2,
    },
    {
      name: 'Settings',
      path: '/settings',
      icon: FiTool,
    },
    {
      name: 'FAQ',
      path: '/faq',
      icon: FiHelpCircle,
    },
  ];

  // Add admin item if user has admin access
  if (hasAdminAccess) {
    navItems.push({
      name: 'Admin',
      path: '/admin',
      icon: FiSettings,
    });
  }

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  return (
    <div
      className={`bg-white border-r border-gray-200 h-screen transition-all duration-300 ease-in-out ${
        isExpanded ? 'w-64' : 'w-16'
      }`}
    >
      {/* Header with toggle button */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        {isExpanded && (
          <img
            src="/distributely-logo-590x100.png"
            alt="Distributely Logo"
            className="h-8 w-auto max-w-[180px]"
          />
        )}
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          aria-label={isExpanded ? 'Collapse navigation' : 'Expand navigation'}
        >
          {isExpanded ? (
            <FiX className="w-5 h-5 text-gray-600" />
          ) : (
            <FiMenu className="w-5 h-5 text-gray-600" />
          )}
        </button>
      </div>

      {/* Navigation items */}
      <nav className="mt-4">
        <ul className="space-y-2 px-3">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = isActiveRoute(item.path);
            
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center px-3 py-2 rounded-lg transition-colors duration-200 ${
                    isActive
                      ? 'bg-blue-100 text-blue-700 border border-blue-200'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                  title={!isExpanded ? item.name : ''}
                >
                  <Icon className={`w-5 h-5 ${isActive ? 'text-blue-700' : 'text-gray-500'}`} />
                  {isExpanded && (
                    <span className="ml-3 font-medium">{item.name}</span>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}
